module.exports = __webpack_public_path__ + "static/img/taocan.349ab6ae.png";